<div class="tt-w-gallery-widget">
  <tt-gallery :skus="skus" :tags="tags" @onFinish="onFinish" :galleryConfig="galleryConfig" :headingLevel="galleryConfig.headingLevel"></tt-gallery>
</div>